import { ApiStrategyTemplate } from '../../../api/_legacy/generated-api'
import { AssetCard } from '../../../components/core-v2/molecules/asset-card'

export type StrategiesViewProps = {
  onSelectStrategy: (strategyTemplateId: string) => void
  selectedStrategy?: ApiStrategyTemplate
  strategies: ApiStrategyTemplate[]
}

const StrategiesView = (props: StrategiesViewProps) => {
  const { strategies } = props
  const { selectedStrategy } = props
  const { onSelectStrategy } = props

  return (
    <ul className="client-list">
      {strategies.map(strategy => (
        <AssetCard
          key={strategy.strategyTemplateId}
          assetId=""
          assetName={strategy.strategyName}
          isSelected={
            selectedStrategy && strategy.strategyTemplateId === selectedStrategy.strategyTemplateId
          }
          onClickAsset={() => onSelectStrategy(strategy.strategyTemplateId)}
        />
      ))}
    </ul>
  )
}

export default StrategiesView
